export default "__VITE_ASSET__CziaoGMk__"